var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.22211 23.111L-0.246338 23.1109H0.888945V23.111H-0.22211ZM12.0001 15.3333C11.0742 15.3333 10.2871 15.0092 9.639 14.361C8.99085 13.7129 8.66678 12.9258 8.66678 11.9999C8.66678 11.074 8.99085 10.287 9.639 9.63881C10.2871 8.99066 11.0742 8.66659 12.0001 8.66659C12.926 8.66659 13.7131 8.99066 14.3612 9.63881C15.0094 10.287 15.3334 11.074 15.3334 11.9999C15.3334 12.9258 15.0094 13.7129 14.3612 14.361C13.7131 15.0092 12.926 15.3333 12.0001 15.3333ZM4.22233 18.6666C3.61122 18.6666 3.08808 18.449 2.65289 18.0138C2.21771 17.5786 2.00011 17.0555 2.00011 16.4444V7.55547C2.00011 6.94436 2.21771 6.42122 2.65289 5.98603C3.08808 5.55084 3.61122 5.33325 4.22233 5.33325H19.7779C20.389 5.33325 20.9122 5.55084 21.3473 5.98603C21.7825 6.42122 22.0001 6.94436 22.0001 7.55547V16.4444C22.0001 17.0555 21.7825 17.5786 21.3473 18.0138C20.9122 18.449 20.389 18.6666 19.7779 18.6666H4.22233ZM6.44456 16.4444H17.5557C17.5557 15.8333 17.7733 15.3101 18.2084 14.8749C18.6436 14.4397 19.1668 14.2221 19.7779 14.2221V9.7777C19.1668 9.7777 18.6436 9.5601 18.2084 9.12492C17.7733 8.68973 17.5557 8.16659 17.5557 7.55547H6.44456C6.44456 8.16659 6.22696 8.68973 5.79178 9.12492C5.35659 9.5601 4.83345 9.7777 4.22233 9.7777V14.2221C4.83345 14.2221 5.35659 14.4397 5.79178 14.8749C6.22696 15.3101 6.44456 15.8333 6.44456 16.4444Z",
    fill: "#373737"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_6141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.ebc21e8327189bd5ddbf62be0c8380d5.svg";
export { ForwardRef as ReactComponent };